 <style>
     span.k-widget.k-datepicker {
         width: 100%;
         height: calc(1.54em + 0.876rem + 2px);
     }
 </style>
<template>
    <kendo-datepicker v-model="model"
                      v-bind="$attrs"
                      v-mask="'##/##/####'"
                      :format="'dd/MM/yyyy'"
                      :required="required"
                      :disabled="disabled"
                      :max="maxToday ? new Date() : maxD"
                      :min="minD"
                      :placeholder="placeholder"
                      @input="inputDefault"></kendo-datepicker>
</template>

<script>
    export default {
        props: {
            value: null,
            input: { type: Function, default: null },
            required: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            maxToday: { type: Boolean, default: false },
            minD: { type: Date },
            maxD: { type: Date, default: () => new Date(2099, 11, 31) },
            placeholder: { default: '' }
        },
        methods: {
            inputDefault: function (val) {
                this.$set(val, this.model)
                if (this.input)
                    this.input(val)
            }
        },
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', kendo.parseDate(value))
                }
            }
        }
    };
</script>